/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonAppointmentRequest } from './PersonAppointmentRequest';
import {
    PersonAppointmentRequestFromJSON,
    PersonAppointmentRequestFromJSONTyped,
    PersonAppointmentRequestToJSON,
    PersonAppointmentRequestToJSONTyped,
} from './PersonAppointmentRequest';
import type { UpdateAppointmentLocation } from './UpdateAppointmentLocation';
import {
    UpdateAppointmentLocationFromJSON,
    UpdateAppointmentLocationFromJSONTyped,
    UpdateAppointmentLocationToJSON,
    UpdateAppointmentLocationToJSONTyped,
} from './UpdateAppointmentLocation';

/**
 * Request for an appointment
 * @export
 * @interface AppointmentRequest
 */
export interface AppointmentRequest {
    /**
     * Tell if the patient has an appointment or not
     * @type {boolean}
     * @memberof AppointmentRequest
     */
    isPatientWithoutAppointment?: boolean;
    /**
     * date of appointment
     * @type {string}
     * @memberof AppointmentRequest
     */
    date?: string;
    /**
     * start time of appointment
     * @type {string}
     * @memberof AppointmentRequest
     */
    time?: string;
    /**
     * appointment duration (min)
     * @type {number}
     * @memberof AppointmentRequest
     */
    duration?: number;
    /**
     * Unique identifier of the appointment type
     * @type {string}
     * @memberof AppointmentRequest
     */
    appointmentTypeId?: string;
    /**
     * Unique identifier of the patient
     * @type {string}
     * @memberof AppointmentRequest
     */
    patientId?: string;
    /**
     * Appointment comment
     * @type {string}
     * @memberof AppointmentRequest
     */
    comment?: string;
    /**
     * Unique identifier of the doctor
     * @type {string}
     * @memberof AppointmentRequest
     */
    doctorId?: string;
    /**
     * 
     * @type {UpdateAppointmentLocation}
     * @memberof AppointmentRequest
     */
    location?: UpdateAppointmentLocation;
    /**
     * Departure date
     * @type {string}
     * @memberof AppointmentRequest
     */
    departureTime?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentRequest
     */
    portalUserUuid?: string;
    /**
     * 
     * @type {PersonAppointmentRequest}
     * @memberof AppointmentRequest
     */
    personAppointment?: PersonAppointmentRequest;
}

/**
 * Check if a given object implements the AppointmentRequest interface.
 */
export function instanceOfAppointmentRequest(value: object): value is AppointmentRequest {
    return true;
}

export function AppointmentRequestFromJSON(json: any): AppointmentRequest {
    return AppointmentRequestFromJSONTyped(json, false);
}

export function AppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isPatientWithoutAppointment': json['isPatientWithoutAppointment'] == null ? undefined : json['isPatientWithoutAppointment'],
        'date': json['date'] == null ? undefined : json['date'],
        'time': json['time'] == null ? undefined : json['time'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'doctorId': json['doctorId'] == null ? undefined : json['doctorId'],
        'location': json['location'] == null ? undefined : UpdateAppointmentLocationFromJSON(json['location']),
        'departureTime': json['departureTime'] == null ? undefined : json['departureTime'],
        'portalUserUuid': json['portalUserUuid'] == null ? undefined : json['portalUserUuid'],
        'personAppointment': json['personAppointment'] == null ? undefined : PersonAppointmentRequestFromJSON(json['personAppointment']),
    };
}

export function AppointmentRequestToJSON(json: any): AppointmentRequest {
    return AppointmentRequestToJSONTyped(json, false);
}

export function AppointmentRequestToJSONTyped(value?: AppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isPatientWithoutAppointment': value['isPatientWithoutAppointment'],
        'date': value['date'],
        'time': value['time'],
        'duration': value['duration'],
        'appointmentTypeId': value['appointmentTypeId'],
        'patientId': value['patientId'],
        'comment': value['comment'],
        'doctorId': value['doctorId'],
        'location': UpdateAppointmentLocationToJSON(value['location']),
        'departureTime': value['departureTime'],
        'portalUserUuid': value['portalUserUuid'],
        'personAppointment': PersonAppointmentRequestToJSON(value['personAppointment']),
    };
}

